export function getOperatingSystem(): string {
  const userAgent = window.navigator.userAgent;
  if (userAgent.indexOf('Windows') !== -1) return 'Windows';
  if (userAgent.indexOf('Mac') !== -1) return 'MacOS';
  if (userAgent.indexOf('Linux') !== -1) return 'Linux';
  if (/iPhone|iPad|iPod/.test(userAgent)) return 'MacOS';
  if (userAgent.indexOf('Android') !== -1) return 'Android';
  return 'Unknown';
}

export const getUrl = (docId: string, platform = 'desktop') => {
  const [source, did] = docId.split('|');
  return platform === 'desktop'
    ? `/browses/detail/${source}/${did}`
    : `/m/browses/detail/${source}/${did}`;
};

export const isWx = () => {
  return window.navigator.userAgent?.includes('MicroMessenger');
};

export function isMobileDevice(): boolean {
  if (typeof window === 'undefined') return false;

  const ua = window.navigator.userAgent?.toLowerCase() || '';

  // 移动设备常见标识
  const mobileKeywords = [
    'mobile',
    'android',
    'iphone',
    'ipod',
    'ipad',
    'windows phone',
    'blackberry',
    'webos',
    'opera mini',
    'iemobile',
  ];

  // 屏幕宽度判断（移动端通常小于768px）
  const isSmallScreen = window.innerWidth <= 768;

  // 触摸支持判断
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // 如果包含移动关键词 或 小屏幕且有触摸支持
  return (
    mobileKeywords.some((keyword) => ua.includes(keyword)) ||
    (isSmallScreen && hasTouch)
  );
}
